const ANE_GROUP_ID = "45aa9f9c-a73a-4221-a764-7a7d577506c7";
const CHECK_GROUP_LOCAL_STORAGE_KEY = "IsAneGroupMember.v3";
export {
  ANE_GROUP_ID,
  CHECK_GROUP_LOCAL_STORAGE_KEY
};
//# sourceMappingURL=AnEGroup.constants.js.map
